import { EXCLUDING_THEMIS_SPAM_SAFE_OPTION } from '../constants'
import { URL_STATE_CHANGE } from '../List/constants'

import {
  CHALLENGED_TYPE_FILTER_CHANGE,
  DEFAULT_SORTING_OPTION,
  GENERAL_FILTER_CHANGE,
  getLocalStorageIncidentsSortingKey,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SORTING_FILTER_CHANGE,
  SORTING_FILTER_RESET,
} from './constants'

const initialState = {
  search: '',
  sortingBy: DEFAULT_SORTING_OPTION.unclassifiedSortingBy,
  // Direction for the active column sort. Legacy TopBar only ever sorts desc; the redesign
  // table cycles default → desc → asc and stores the active direction here.
  sortingDirection: 'desc',
  generalFilter: EXCLUDING_THEMIS_SPAM_SAFE_OPTION.value,
  challengedTypeFilter: undefined,
}
export default function () {
  return (state = initialState, action) => {
    switch (action.type) {
      case SEARCH_RESET:
        return {
          ...state,
          search: '',
        }
      case URL_STATE_CHANGE: {
        // Always adopt the tab's default sort. Redesign preserveFilters keeps search + challenge
        // type across tabs; legacy still clears both.
        const { urlState, preserveFilters, incidentsRedesign } = action.payload
        const sortingKey = getLocalStorageIncidentsSortingKey(urlState, { incidentsRedesign })
        return {
          ...state,
          search: preserveFilters ? state.search : '',
          challengedTypeFilter: preserveFilters
            ? state.challengedTypeFilter
            : initialState.challengedTypeFilter,
          sortingBy: DEFAULT_SORTING_OPTION[sortingKey],
          sortingDirection: 'desc',
        }
      }
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
        }
      case SORTING_FILTER_CHANGE:
        return {
          ...state,
          sortingBy: action.payload.value,
          sortingDirection: action.payload.direction || 'desc',
        }
      case SORTING_FILTER_RESET:
        return {
          ...state,
          sortingBy: DEFAULT_SORTING_OPTION[action.payload.key],
          sortingDirection: 'desc',
        }
      case GENERAL_FILTER_CHANGE:
        return { ...state, generalFilter: action.payload.value }
      case CHALLENGED_TYPE_FILTER_CHANGE:
        return { ...state, challengedTypeFilter: action.payload.value }
      default:
        return state
    }
  }
}
